angular.module('quattro.bmbo.login.password-set', [
    'ngRoute',
    'quattro.core.hpls_api_1',
    'quattro.core.form-helper.checkval',
    'quattro.core.password-form',
])
    .controller('BmboPasswordSetController', function ($routeParams, $q, api) {

        var key = $routeParams.key;

        this.sent = false;

        this.validatePassword = function (value) {
            // FIXME: add api call
            return $q.when();
        };

        this.save = function () {

            // FIXME: add api call
            console.log(this.password, key);

            this.sent = true;
        };
    });
